import React, { useState, useEffect } from 'react'
import ArrowDownIco from 'src/static/icons/ico_arrow_down.svg'
import MultiRangeSlider from '../utils/MultiRangeSlider'
import { PriceProps } from 'src/types/Main'
import PriceOptions from './priceOptions'
import useI18n from 'src/hooks/useI18n'

interface Props {
  index?: number;
  currentActive?: number | null;
  isOpen?: boolean;
  mode: string;
  startOpen: boolean;
  minPrice: number;
  maxPrice: number;
  priceProps?: PriceProps;
  resetMode: string;
  filteredMinPrice: number;
  filteredMaxPrice: number;
  setFilteredMinPrice(min: number): void;
  setFilteredMaxPrice(max: number): void;
  filterOnClick: boolean;
  clearPriceFilter(price: string): void;
  openTab?: Function;
}

const PriceFilter = (props: Props) => {
  const {
    index,
    currentActive,
    isOpen,
    mode,
    startOpen,
    minPrice,
    maxPrice,
    priceProps,
    resetMode,
    filteredMinPrice,
    filteredMaxPrice,
    setFilteredMinPrice,
    setFilteredMaxPrice,
    clearPriceFilter,
    filterOnClick,
    openTab
  } = props

  const isTab = (index === currentActive && isOpen && openTab)
  const isHorizontalMode = (mode === 'horizontal')
  const startOpenMode = (startOpen && !isHorizontalMode)
  const priceAppliedMode = (filteredMinPrice || filteredMaxPrice) && !isHorizontalMode

  const toggleFilter = () => {
    if (isTab || startOpenMode || priceAppliedMode) {
      return true
    }
    return false
  }

  const BASE_CLASS_CSS = 'filter-price'

  const [open, setOpen] = useState<boolean>(toggleFilter())

  useEffect(() => {
    if (openTab) setOpen(toggleFilter())
  })

  const translation = useI18n()

  const handleOpen = () => {
    if (openTab) {
      openTab(index, BASE_CLASS_CSS, translation.filter.price)
    } else {
      const eventName = open ? 'vnda:filter-component-item-close' : 'vnda:filter-component-item-open'
      const customOpenEvent = new CustomEvent(eventName, {
        detail: {
          itemClass: BASE_CLASS_CSS,
          itemName: translation.filter.price
        }
      })
      window.dispatchEvent(customOpenEvent)
    }
    setOpen(!open)
  }

  const resetFilter = (event: React.MouseEvent) => {
    event.stopPropagation()
    clearPriceFilter('')
  }

  const handlesMinPriceFilter = async (min: number) => {
    setFilteredMinPrice(min)
  }

  const handlesMaxPriceFilter = async (max: number) => {
    setFilteredMaxPrice(max)
  }

  return (
    <div
      className={`${BASE_CLASS_CSS}-container filter-item-container ${open ? 'filter-item-open' : ''}`}>
      <div
        className={`${BASE_CLASS_CSS}-header filter-item-header`}
        onClick={handleOpen}
      >
        <div className={`${BASE_CLASS_CSS}-header-container filter-item-header-container`}>
          <span className="filter-item-title">
            {translation.filter.price}
          </span>
          <div className="arrow-container">
            <img className="arrow-image" src={ArrowDownIco} />
          </div>
        </div>
        {resetMode === 'each' && (
          <span
            className={`${BASE_CLASS_CSS}-header-clear filter-item-clear`}
            onClick={resetFilter}
          >
            {translation.filter.clean}
          </span>
        )}
      </div>
      <div
        className={`${BASE_CLASS_CSS}-content filter-item-content ${open ? '-open' : ''} `}>
        { priceProps?.mode === 'slider' && (
          <MultiRangeSlider
            min={minPrice}
            max={maxPrice}
            filteredMin={filteredMinPrice}
            filteredMax={filteredMaxPrice}
            formatNumber={(value: number) => `${translation.filter.currency} ${value.toFixed(2).replace('.', ',')}`}
            onChangeMin={(min: number) => {
              handlesMinPriceFilter(min)
            }}
            onChangeMax={(max: number) => {
              handlesMaxPriceFilter(max)
            }}
          />
        )}
        { priceProps?.mode === 'options' && (
          <PriceOptions
            options={priceProps.options}
            filteredMinPrice={filteredMinPrice}
            filteredMaxPrice={filteredMaxPrice}
            setFilteredMinPrice={setFilteredMinPrice}
            setFilteredMaxPrice={setFilteredMaxPrice}
            filterOnClick={filterOnClick}
            formatNumber={(value: number) => `${translation.filter.currency} ${value.toFixed(2).replace('.', ',')}`}
          />
        )}
      </div>
    </div>
  )
}

export default PriceFilter
